import request from 'utils/request';
import { keysToSnakeCase, keysToCamelCase } from 'utils/stringUtils';

// export type Address = {
//   country: ?{
//     abbr: 'USA' | 'CAN',
//     name: string,
//   },
//   state: ?{
//     abbr: string,
//     name: string,
//   },
//   city: ?string,
//   address1: ?string,
//   address2: ?string,
//   postalCode: ?string,
// };

// export type AddressInfo = {|
//   address: Address,
//   businessName: string,
//   firstName: string,
//   lastName: string,
// |};

export const transformAddressToApi = (data) => {
  return keysToSnakeCase(data);
};

export const transformAddressInfoToApi = (data) => {
  const result = keysToSnakeCase(data);
  result.address = transformAddressToApi(result.address);
  return result;
};

export const transformApiToAddress = (data) => {
  const result = keysToCamelCase(data);
  if (result.address) {
    result.address = keysToCamelCase(result.address);
  }
  return result;
};

export default {
  validateInformation: async (data) => {
    const response = await request.post(
      '/addresses/validate_information',
      data,
    );
    return {
      isValid: response.isValid,
      originalAddress: data,
      suggestedAddresses: response.candidates,
    };
  },
  validateAddress: async (data) => {
    const response = await request.post('/addresses/validate_address', data);
    return {
      isValid: response.isValid,
      originalAddress: data,
      suggestedAddresses: response.candidates,
    };
  },
};
